import { render } from "./FilterProximaTurma.vue?vue&type=template&id=694c3550&scoped=true"
import script from "./FilterProximaTurma.vue?vue&type=script&lang=js"
export * from "./FilterProximaTurma.vue?vue&type=script&lang=js"

import "./FilterProximaTurma.vue?vue&type=style&index=0&id=694c3550&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694c3550"]])

export default __exports__